export enum LeaseType {
  NEW_LEASE = 'NEW_LEASE',
  RENEWAL = 'RENEWAL',
  SUBLEASE = 'SUBLEASE',
}
